import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import MenuPage from "@/pages/MenuPage";

function App() {
  return (
    <div className="App bg-ink min-h-screen">
      <div className="grain-overlay" />
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<MenuPage />} />
            <Route path="*" element={<MenuPage />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
